(function () {
  var map;
  var geocoder;
  var address = [];
  var selectedShape = null;
  var lastSelectedShape = null;
  var selectedArea = [];
  // var imageDim = {height: 640, width: 640};
  var imageDim = { height: 360, width: 1000 };
  var markers = [];
  var drawingManager;
  var GOOGLE_MAPS_KEY = "AIzaSyDYb9Bc-pOz1h61georfV3hu9c4K8iXEdA";
  var colors;

  var init = function () {
    geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        address: $("input[name='address']").val(),
      },
      function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          var center = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          };
          map = new google.maps.Map(document.getElementById("map"), {
            zoom: 18,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            rotateControl: false,
            center: center,
          });
        } else {
          map = new google.maps.Map(document.getElementById("map"), {
            center: Utils.getUSACenter(),
            zoom: 4,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            rotateControl: false,
          });
        }

        map.setTilt(0);

        drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ["polygon"],
          },
          polygonOptions: {
            fillOpacity: 0,
            strokeWeight: 5,
            strokeColor: "#0EA2C8",
            zIndex: 1,
            editable: false,
          },
        });

        drawingManager.setMap(map);

        var removePolygonButton = document.createElement("div");

        addCustomControl(removePolygonButton, "polygon");

        removePolygonButton.index = 1;

        map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          removePolygonButton
        );

        // Listen for the event fired when the user selects a prediction and retrieve
        // more details for that place.
        google.maps.event.addListener(
          drawingManager,
          "overlaycomplete",
          savePolygon
        );

        if (!google.maps.Polygon.prototype.getBounds) {
          google.maps.Polygon.prototype.getBounds = function () {
            var bounds = new google.maps.LatLngBounds();
            this.getPath().forEach(function (element, index) {
              bounds.extend(element);
            });
            return bounds;
          };
        }

        MapController.Evaluations.setSelectedArea();
      }
    );
  };

  $(document).on("click", ".evaluations-next-map", function () {
    createMapImage();
  });

  function savePolygon(event) {
    if (event.type && event.type === google.maps.drawing.OverlayType.POLYGON) {
      clearSelection();
      selectedShape = event.overlay;
    }
  }

  function addCustomControl(controlDiv, type) {
    if (type === "polygon") {
      addSpecificCustomControl(
        controlDiv,
        "Clear selected area from the map",
        '<i class="small material-icons" style="font-size: 20px !important;">clear</i>',
        clearSelection
      );
    } else if (type === "marker") {
      addSpecificCustomControl(
        controlDiv,
        "Clear markers from the map",
        '<img src="' +
          $("body").attr("data-base-url") +
          "assets/img/remove-pin.png" +
          '" style="height:16px"/>',
        clearMarkers
      );
    }
  }

  var addSpecificCustomControl = function (
    controlDiv,
    tooltip,
    icon,
    callback
  ) {
    var ui = document.createElement("div");
    ui.style.backgroundColor = "#fff";
    ui.style.border = "2px solid #fff";
    ui.style.borderRadius = "2px 2px 2px 2px";
    ui.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    ui.style.cursor = "pointer";
    ui.style.marginBottom = "22px";
    ui.style.marginTop = "5px";
    ui.style.marginLeft = "5px";
    ui.style.textAlign = "center";
    ui.style.height = "23px";
    ui.style.width = "23px";
    ui.classList.add("mapTooltip");
    ui.setAttribute("data-position", "bottom");
    ui.setAttribute("data-tooltip", tooltip);
    controlDiv.appendChild(ui);

    var button = document.createElement("div");
    button.style.color = "rgb(25,25,25)";
    button.style.fontFamily = "Roboto,Arial,sans-serif";
    button.style.fontSize = "16px";
    button.style.lineHeight = "38px";
    button.innerHTML = icon;
    ui.appendChild(button);

    button.addEventListener("click", function () {
      callback();
    });
  };
  function addMarker(marker) {
    dataToSave = true;
    var latPinEl = $("input[name='evaluation[map_pin_lat]']");
    var lngPinEl = $("input[name='evaluation[map_pin_lng]']");
    var latitude = $("input[name='evaluation[latitude]']");
    var longitude = $("input[name='evaluation[longitude]']");

    latPinEl.val(marker.getPosition().lat());
    lngPinEl.val(marker.getPosition().lng());
    latitude.val(marker.getPosition().lat());
    longitude.val(marker.getPosition().lng());
    clearMarkers();
    markers.push(marker);
  }

  function clearMarkers() {
    setMapOnAll(null);
    markers = [];
  }

  function setMapOnAll(map) {
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(map);
    }
  }

  function clearSelection() {
    if (selectedShape) {
      selectedShape.setEditable(false);
      selectedShape.setMap(null);
      lastSelectedShape = selectedShape;
      selectedShape = null;
    }
  }

  function createMapImage() {
    if (selectedShape !== null && selectedShape !== undefined) {
      // Switch back to non-drawing mode after drawing a shape.
      drawingManager.setDrawingMode(null);

      var path = selectedShape.getPath();
      // Add the first point as the last point, so all the markers are connected
      selectedShape.getPath().push(selectedShape.getPath().getAt(0));

      selectedShape.getPath().forEach(function (element, index) {
        selectedArea.push({ lat: element.lat(), lng: element.lng() });
      });

      var encodeString = google.maps.geometry.encoding.encodePath(path);

      var lat = selectedShape.getBounds().getCenter().lat();
      var lng = selectedShape.getBounds().getCenter().lng();

      getImage(GOOGLE_MAPS_KEY, encodeString, lat, lng);

      setSelection(selectedShape);
    } else {
      saveToDatabase();
    }
  }

  function getBoundsZoomLevel(bounds) {
    var WORLD_DIM = { height: 256, width: 256 };

    var ZOOM_MAX = 21;

    function latRad(lat) {
      var sin = Math.sin((lat * Math.PI) / 180);
      var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
      return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

    var latZoom = zoom(imageDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(imageDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
  }

  function setSelection(shape) {
    //clearSelection();
    selectedShape = shape;
    shape.setEditable(false);
  }

  function setArea(shape) {
    //clearSelection();
    selectedShape = shape;
    shape.setEditable(false);
  }

  function getImage(GOOGLE_MAPS_KEY, encodeString, lat, lng) {
    var zoomBounds = map.getZoom()
      ? map.getZoom()
      : getBoundsZoomLevel(selectedShape.getBounds());
    var zoomForImg = zoomBounds;
    if (zoomForImg > getBoundsZoomLevel(selectedShape.getBounds()))
      zoomForImg = getBoundsZoomLevel(selectedShape.getBounds());
    var enc = encodeString;
    var size = imageDim.width + "x" + imageDim.height;
    var zoom = zoomForImg ? zoomForImg : 16;
    var center = lat + "," + lng;
    var path = "color:0x0EA2C8ff|weight:6|";
    var type = "satellite";
    var imageUrl =
      "https://maps.googleapis.com/maps/api/staticmap?size=" +
      size +
      "&zoom=" +
      zoom +
      "&center=" +
      center +
      "&scale=" +
      2 +
      "&maptype=" +
      type +
      "&path=" +
      path +
      "enc:" +
      enc +
      "&key=" +
      GOOGLE_MAPS_KEY;

    var imageWithPin = getImageWithPin(GOOGLE_MAPS_KEY, lat, lng);

    saveToDatabase(imageUrl, zoom, lat, lng, imageWithPin);
  }

  function getImageWithPin(GOOGLE_MAPS_KEY, lat, lng) {
    var size = 600 + "x" + 300;
    var zoom = 16;
    var center = lat + "," + lng;
    var type = "roadmap";
    var icon =
      $("body").attr("data-base-url") + "assets/img/marker_20180816.png";

    return (
      "https://maps.googleapis.com/maps/api/staticmap?size=" +
      size +
      "&zoom=" +
      zoom +
      "&center=" +
      center +
      "&scale=" +
      2 +
      "&maptype=" +
      type +
      "&markers=icon:" +
      icon +
      "|" +
      center +
      "&key=" +
      GOOGLE_MAPS_KEY
    );
  }

  function assemble(imageUrl, zoom, lat, lng, imageWithPin) {
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(), // OK
        client_id: $('input[name="evaluation[client_id]"]').val(),
        account_id: $('input[name="evaluation[account_id]"]').val(),
        user_id: $('input[name="evaluation[user_id]"]').val(),
        position: $('input[name="evaluation[position]"]').val(),
        property_boundaries: {},
      },
    };

    if (imageUrl && zoom && lat && lng) {
      //Save image
      if (imageUrl) {
        data.evaluation.map_image_url = imageUrl;
        data.evaluation.map_image_for_report_url = imageWithPin;
      }

      //Save lat and lng
      if (lat && lng) {
        data.evaluation.latitude = lat;
        data.evaluation.longitude = lng;
        data.evaluation.map_selected_area = selectedArea;
      }

      //Save zoom
      if (zoom) {
        data.evaluation.map_zoom = zoom;
      }
    }

    return data;
  }

  function saveToDatabase(imageUrl, zoom, lat, lng, imageWithPin) {
    var data = assemble(imageUrl, zoom, lat, lng, imageWithPin);

    var url = "evaluations/save";
    if (location.pathname.indexOf("/res_evaluations") !== -1) {
      url = "res_evaluations/save";
    }

    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + url,
      data: data,
      beforeSend: function (xhr) {
        startLoading("#map-wrapper");
      },
      success: function (responseText) {
        var response = JSON.parse(responseText);
        var form = $("#evaluation-form");

        if (response.status.localeCompare("success") === 0) {
          saveToast();
          if (location.pathname.indexOf("/res_evaluations") !== -1) {
            window.location.href = ResEvaluationController.createURI(
              form.attr("data-next"),
              response.id
            );
          } else {
            window.location.href = EvaluationController.createURI(
              form.attr("data-next"),
              response.id
            );
          }
        } else {
          Materialize.toast(response.message);
        }
        stopLoading("#map-wrapper");
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
        stopLoading("#map-wrapper");
      },
    });
  }

  var setSelectedArea = function () {
    var url = "evaluations/get";
    if (location.pathname.indexOf("/res_evaluations") !== -1) {
      url = "res_evaluations/get";
    }
    $.ajax({
      type: "GET",
      url: $("body").data("base-url") + url,
      data: { id: $('input[name="evaluation[id]"]').val() },
      success: function (responseText) {
        var response = JSON.parse(responseText);

        if (response.map_selected_area) {
          var map_selected_area = JSON.parse(response.map_selected_area);
          if (map_selected_area && map_selected_area.length > 0) {
            for (var j = 0; j < map_selected_area.length; j++) {
              map_selected_area[j].lat = parseFloat(map_selected_area[j].lat);
              map_selected_area[j].lng = parseFloat(map_selected_area[j].lng);
            }

            var area = new google.maps.Polygon({
              paths: map_selected_area,
              fillOpacity: 0,
              strokeWeight: 5,
              strokeColor: "#0EA2C8",
              zIndex: 1,
              editable: false,
            });

            area.setMap(map);

            setArea(area);
            map.setCenter(
              new google.maps.LatLng(
                parseFloat(map_selected_area[0].lat),
                parseFloat(map_selected_area[0].lng)
              )
            );
          } else if (response.latitude && response.longitude) {
            //If no selected area, then use lat and long
            map.setCenter(
              new google.maps.LatLng(response.latitude, response.longitude)
            );
            map.setZoom(20);
          }
        } else {
          if (response.latitude && response.longitude) {
            //If no selected area, then use lat and long
            map.setCenter(
              new google.maps.LatLng(response.latitude, response.longitude)
            );
            map.setZoom(20);
          } else {
            address.push(response.street_address);
            address.push(response.city);
            address.push(response.state);
            address.push(response.zipcode);

            var geocoder = new google.maps.Geocoder();

            geocoder.geocode(
              { address: address.join(",") },
              function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                  map.setZoom(20);
                  map.setCenter(
                    new google.maps.LatLng(
                      results[0].geometry.location.lat(),
                      results[0].geometry.location.lng()
                    )
                  );
                }
              }
            );
          }
        }

        if (response.map_zoom) {
          map.setZoom(parseInt(response.map_zoom));
        }
      },
      failure: function (errMsg) {
        Materialize.toast("It was not possible to execute that action.", 2000);
      },
    });
  };

  var setPin = function (latitude, longitude) {
    var myLatLng = { lat: latitude, lng: longitude };
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
    });

    markers.push(marker);
  };

  var initPin = function () {
    map = new google.maps.Map(document.getElementById("map-pin"), {
      center: getCenter(),
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.HYBRID,
      rotateControl: false,
    });

    map.setTilt(0);

    drawingManager = new google.maps.drawing.DrawingManager({
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: ["marker"],
      },
    });

    drawingManager.setMap(map);

    var removeMarkerButton = document.createElement("div");

    addCustomControl(removeMarkerButton, "marker");

    removeMarkerButton.index = 1;

    map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      removeMarkerButton
    );

    google.maps.event.addListener(drawingManager, "markercomplete", addMarker);

    google.maps.event.addListener(map, "zoom_changed", setSelectedPinZoom);

    addTooltips();
  };

  var setSelectedPinZoom = function () {
    $("input[name='evaluation[map_pin_zoom]']").val(map.getZoom());
  };

  var setSelectedPin = function () {
    var latPinEl = $("input[name='evaluation[map_pin_lat]']");
    var lngPinEl = $("input[name='evaluation[map_pin_lng]']");

    var latitude = $("input[name='evaluation[latitude]']").val();
    var longitude = $("input[name='evaluation[longitude]']").val();

    var pinLatitude = latPinEl.val();
    var pinLongitude = lngPinEl.val();

    if (pinLatitude.length && pinLongitude.length) {
      latitude = pinLatitude;
      longitude = pinLongitude;
    }

    if (latitude.length && longitude.length) {
      latPinEl.val(latitude);
      lngPinEl.val(longitude);

      clearMarkers();

      setPin(parseFloat(latitude), parseFloat(longitude));

      if (markers.hasOwnProperty(0)) {
        var zoomEl = $("input[name='evaluation[map_pin_zoom]']");
        var zoom = zoomEl.val();

        if (zoom.length) {
          map.setZoom(parseInt(zoom));
          map.panTo(markers[0].position);
        } else {
          if ($("#route").val().length) {
            zoomEl.val(16);
            map.setZoom(16);
            map.panTo(markers[0].position);
          } else {
            zoomEl.val(4);
            map.setZoom(4);
          }
        }
      }
    }
  };

  var addTooltips = function () {
    setTimeout(function () {
      $(".gmnoprint").each(function () {
        addTooltip($(this), "Stop drawing", "Click here to stop the drawing");
        addTooltip(
          $(this),
          "Add a marker",
          "Click here to add a marker to your map"
        );
        addTooltip(
          $(this),
          "Draw a shape",
          "Click here to draw a shape in your map"
        );
      });

      $(".mapTooltip").tooltip();
    }, 2000);
  };

  var addTooltip = function (obj, key, title) {
    var polygon = obj.find("[title='" + key + "']");
    polygon.attr("data-tooltip", title);
    polygon.attr("data-position", "bottom");
    polygon.addClass("mapTooltip");
  };

  var getCenter = function () {
    var lat = $("input[name='evaluation[latitude]']").val();
    var long = $("input[name='evaluation[longitude]']").val();

    var center = {};
    if (lat.length > 0 && long.length > 0) {
      center = {
        lat: parseFloat(lat),
        lng: parseFloat(long),
      };
    }

    return center.lat && center.lng ? center : Utils.getUSACenter();
  };

  var getKey = function () {
    return GOOGLE_MAPS_KEY;
  };

  var getMap = function () {
    return map;
  };

  if (window.MapController === undefined) {
    window.MapController = {};
  }

  if (MapController.Evaluations === undefined) {
    MapController.Evaluations = {};
  }
  if (MapController.EvaluationsPin === undefined) {
    MapController.EvaluationsPin = {};
  }

  var arialinit = function () {
    var address = $("input[name='arial-address']").val();
    var zoom = 14;
    if (
      $("input[name='evaluation[map_pin_zoom]']").length &&
      $("input[name='evaluation[map_pin_zoom]']").val()
    )
      zoom = parseInt($("input[name='evaluation[map_pin_zoom]']").val());
    else $("input[name='evaluation[map_pin_zoom]']").val(zoom);
    map = new google.maps.Map(document.getElementById("map-pin"), {
      center: getCenter(),
      zoom: zoom,
      gestureHandling: "greedy",
      streetViewControl: false,
      mapTypeControlOptions: {
        mapTypeIds: ["styled_map", "hybrid", "roadmap"],
      },
      mapTypeId: $('input[name="evaluation[map_type_id]"]').val(),
    });
    setSubjectProperty(map, address);
    setTimeout(function () {
      google.maps.event.addListener(map, "maptypeid_changed", setMapType);
      google.maps.event.addListener(map, "zoom_changed", setSelectedPinZoom);
    }, 1000);
  };

  var setMapType = function () {
    $("input[name='evaluation[map_type_id]']").val(map.getMapTypeId());
  };

  var loadComps = function (map) {
    var properties = JSON.parse($("#comps").html());
    var colorIndex = 0;

    for (var i in properties) {
      if (properties.hasOwnProperty(i)) {
        var property = properties[i];
        addPinV2(map, property.latitude, property.longitude, colorIndex);
        colorIndex++;
      }
    }
  };

  var addPin = function (map, lat, lng, color, address) {
    var url = "https://maps.google.com/mapfiles/ms/icons/";
    url += color + "-dot.png";
    var xPosition = 0;
    var yPosition = 9;
    var multiplier = 2;
    if (typeof address !== "undefined") {
      var addressLength = address.length;
      if (addressLength >= 23) {
        multiplier = 3;
      }
      xPosition = 50 + addressLength * multiplier;
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        icon: {
          url: url,
          labelOrigin: new google.maps.Point(xPosition, yPosition),
        },
      });
      markers.push(marker);
    }
  };

  var addPinV2 = function (map, lat, lng, index) {
    const pin = pinColor(index);

    // var url = "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld="+ pin.char +"|" + pin.color;
    const url =
      "https://maps.google.com/mapfiles/ms/icons/" + pin.color + "-dot.png";

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      map: map,
      icon: {
        url: url, // URL for the map pin icon
        scaledSize: new google.maps.Size(32, 32), // Adjust size as needed
      },
    });
    markers.push(marker);
  };

  // Function to determine pin color based on index
  function pinColor(index) {
    var colors = ["red", "blue", "green", "yellow", "purple", "orange"]; // colors
    return { color: colors[index % colors.length] };
  }

  // var pinColor = function(index) {
  //     //Devault values
  //     var char = '%E2%80%A2';
  //     var color = '6b94ff';

  //     if(colors[index]) {
  //         char = colors[index].char;
  //         color = colors[index].color;
  //     }

  //     return {'char': char, 'color' : color};
  // };

  var compMapinit = function () {
    startLoading("body");
    var address = $("input[name='arial-address']").val();
    var zoom = 14;
    if (
      $("input[name='map_pin_zoom']").length &&
      $("input[name='map_pin_zoom']").val()
    )
      zoom = parseInt($("input[name='map_pin_zoom']").val());
    map = new google.maps.Map(document.getElementById("map-pin"), {
      center: getCenter(),
      zoom: zoom,
      streetViewControl: false,
      gestureHandling: "greedy",
      mapTypeControlOptions: {
        mapTypeIds: ["styled_map", "hybrid", "roadmap"],
      },
      mapTypeId: $('input[name="evaluation[map_type_id]"]').val(),
    });
    infowindow = new google.maps.InfoWindow();
    if ($("#comps-map-pins").html())
      colors = JSON.parse($("#comps-map-pins").html());
    loadComps(map);
    setSubjectProperty(map, address);
    setCenter(map);
    setTimeout(function () {
      google.maps.event.addListener(map, "maptypeid_changed", setMapType);
      google.maps.event.addListener(map, "zoom_changed", setSelectedPinZoom);
      stopLoading("body");
    }, 100);
  };

  var setCenter = function (map) {
    var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i].getPosition());
    }

    google.maps.event.addListenerOnce(map, "bounds_changed", function (event) {
      var zoom = map.getZoom() - 1;
      if (
        $("input[name='evaluation[map_pin_zoom]']").length &&
        $("input[name='evaluation[map_pin_zoom]']").val()
      )
        zoom = parseInt($("input[name='evaluation[map_pin_zoom]']").val());

      this.setZoom(zoom);

      if (this.getZoom() > 15) {
        this.setZoom(15);
      }
      $("input[name='evaluation[map_pin_zoom]']").val(map.getZoom());
    });

    map.fitBounds(bounds);
  };
  var setSubjectProperty = function (map, address) {
    var lat = $("input[name='evaluation[latitude]']").val();
    var lng = $("input[name='evaluation[longitude]']").val();

    if (lat && lng) {
      addPin(map, lat, lng, "pink", address);
    }
  };
  $(document).on("click", ".evaluations-next-map-aerial", function () {
    createAerialMapImage();
  });
  $(document).on("click", ".evaluations-next-map-comparea", function () {
    saveCompAreaMapZoom();
  });

  $(document).on(
    "click",
    ".evaluations-next-map-multiFamilyCompsMap",
    function () {
      saveMultiFamilyCompMapZoom();
    }
  );

  function saveMultiFamilyCompMapZoom() {
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(),
        multi_family_comps_map_zoom: $(
          "input[name='evaluation[map_pin_zoom]']"
        ).val(),
        multi_family_comps_map_type: $(
          'input[name="evaluation[map_type_id]"]'
        ).val(),
      },
    };
    saveImageToDatabase(data);
  }

  function saveCompAreaMapZoom() {
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(),
        comp_area_map_zoom: $("input[name='evaluation[map_pin_zoom]']").val(),
        comps_map_type: $('input[name="evaluation[map_type_id]"]').val(),
      },
    };
    saveImageToDatabase(data);
  }
  $(document).on(
    "click",
    ".evaluations-next-map-leaseCompAreaMap",
    function () {
      saveLeaseCompAreaMapZoom();
    }
  );

  function saveLeaseCompAreaMapZoom() {
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(),
        lease_comp_area_map_zoom: $(
          "input[name='evaluation[map_pin_zoom]']"
        ).val(),
        lease_comps_map_type: $('input[name="evaluation[map_type_id]"]').val(),
      },
    };
    saveImageToDatabase(data);
  }
  $(document).on("click", ".evaluations-next-map-capCompAreaMap", function () {
    saveCAPCompAreaMapZoom();
  });

  function saveCAPCompAreaMapZoom() {
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(),
        cap_comps_area_map_zoom: $(
          "input[name='evaluation[map_pin_zoom]']"
        ).val(),
        cap_comps_map_type: $('input[name="evaluation[map_type_id]"]').val(),
      },
    };
    saveImageToDatabase(data);
  }

  $(document).on("click", ".evaluations-next-map-costCompAreaMap", function () {
    saveCostCompAreaMapZoom();
  });

  function saveCostCompAreaMapZoom() {
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(),
        cost_comps_area_map_zoom: $(
          "input[name='evaluation[map_pin_zoom]']"
        ).val(),
        cost_comps_map_type: $('input[name="evaluation[map_type_id]"]').val(),
      },
    };
    saveImageToDatabase(data);
  }

  function createAerialMapImage() {
    var zoom = $("input[name='evaluation[map_pin_zoom]']").val();
    var data = {
      evaluation: {
        id: $('input[name="evaluation[id]"]').val(),
        aerial_map_zoom: zoom,
        aerial_map_type: $('input[name="evaluation[map_type_id]"]').val(),
      },
    };
    saveImageToDatabase(data);
  }

  function saveImageToDatabase(data) {
    var url = "evaluations/save";
    if (location.pathname.indexOf("/res_evaluations") !== -1) {
      url = "res_evaluations/save";
    }
    $.ajax({
      type: "POST",
      url: $("body").data("base-url") + url,
      data: data,
      beforeSend: function (xhr) {
        startLoading("#aerial-map-pin-wrapper");
      },
      success: function (responseText) {
        var response = JSON.parse(responseText);
        var form = $("#evaluation-form");

        if (response.status.localeCompare("success") === 0) {
          saveToast();
          if (location.pathname.indexOf("/res_evaluations") !== -1) {
            window.location.href = ResEvaluationController.createURI(
              form.attr("data-next"),
              response.id
            );
          } else {
            window.location.href = EvaluationController.createURI(
              form.attr("data-next"),
              response.id
            );
          }
        } else {
          Materialize.toast(response.message);
        }
      },
      failure: function (errMsg) {
        stopLoading("#aerial-map-pin-wrapper");
        Materialize.toast("It was not possible to execute that action.", 2000);
        stopLoading("#map-wrapper");
      },
    });
  }

  MapController.Evaluations.init = init;
  MapController.Evaluations.setSelectedArea = setSelectedArea;
  MapController.Evaluations.getMap = getMap;
  MapController.getKey = getKey;

  MapController.EvaluationsPin.init = initPin;
  MapController.EvaluationsPin.arialinit = arialinit;
  MapController.EvaluationsPin.compMapinit = compMapinit;
  MapController.EvaluationsPin.setSelectedPin = setSelectedPin;
})();
